import './Pane.css';

function Pane({ children, onNext, onBack, isFirst, isLast, nextDisabled, nextLabel = 'Next', wide }) {
  return (
    <div className={`pane card${wide ? ' pane--wide' : ''}`}>
      <div className="pane-body">{children}</div>
      <div className="pane-actions">
        {!isFirst && (
          <button type="button" className="btn btn-secondary" onClick={onBack}>
            Back
          </button>
        )}
        {!isLast && (
          <button
            type="button"
            className="btn btn-primary"
            disabled={nextDisabled}
            onClick={onNext}
          >
            {nextLabel}
          </button>
        )}
      </div>
    </div>
  );
}

export default Pane;
